// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I3kr","delete":"styles_delete__1vo9h","update":"styles_update__3Xo0T","add":"styles_add__3gmUR"};